export default __webpack_public_path__ + "static/media/web-automation-with-python-language.ae669234.md";